import { render, staticRenderFns } from "./Agentes.vue?vue&type=template&id=df71f154&scoped=true"
import script from "./Agentes.vue?vue&type=script&lang=js"
export * from "./Agentes.vue?vue&type=script&lang=js"
import style0 from "./Agentes.vue?vue&type=style&index=0&id=df71f154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df71f154",
  null
  
)

export default component.exports